import BaseRepository from '@/api/repositories/BaseRepository';

export default class PdfFormAppendixRepository extends BaseRepository {
	getAllAppendixes() {
		return this.get(`pdf-appendixes`, {});
	}
	updateAppendix(id, data) {
		return this.put(`pdf-appendixes/${id}`, {}, data);
	}

	getAppendixFile(id) {
		const timestamp = new Date().getTime();
		return this.get(`pdf-appendixes-file/${id}?_=${timestamp}`, {}, { responseType: 'arraybuffer', headers: { 'Cache-Control': 'no-cache' } });
	}

	changeState(id, data) {
		return this.put(`pdf-appendixes/${id}/changeState`, {}, data);
	}
}
